import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { getAdverseMediaCategoryLabel } from "../utils/adverse-media-utils";

@Component({
  selector: "app-result-adverse-media-article",
  templateUrl: "./result-adverse-media-article.component.html",
  styleUrls: ["./result-adverse-media-article.component.scss"],
})
export class ResultAdverseMediaArticleComponent implements OnInit {
  article: any;
  searchedName = "";
  categoryLabel = "";
  articleBody: SafeHtml = "";
  highlightedHeadline: SafeHtml = "";

  constructor(
    private location: Location,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.searchedName = localStorage.getItem("adverseMediaSearchedName") || "";
    const categoryKey = localStorage.getItem("adverseMediaCategory") || "";
    this.categoryLabel = getAdverseMediaCategoryLabel(categoryKey);

    const stored = localStorage.getItem("adverseMediaArticle");
    this.article = stored ? JSON.parse(stored) : null;

    if (this.article?.headline) {
      this.highlightedHeadline = this.sanitizer.bypassSecurityTrustHtml(
        this.highlightKeywords(this.article.headline, this.searchedName),
      );
    }

    if (this.article?.body) {
      this.articleBody = this.sanitizer.bypassSecurityTrustHtml(
        this.highlightKeywords(this.article.body, this.searchedName),
      );
    }
  }

  goBack() {
    this.location.back();
  }

  /**
   * Highlight search keywords in HTML/text without altering tag attributes.
   * Matches the full query and each whitespace-separated token (length >= 2).
   */
  private highlightKeywords(content: string, keyword: string): string {
    if (!content || !keyword || !keyword.trim()) {
      return content;
    }

    const terms = this.buildHighlightTerms(keyword);
    if (!terms.length) {
      return content;
    }

    const pattern = terms
      .map((term) => this.escapeRegExp(term))
      .join("|");
    const regex = new RegExp(`(${pattern})`, "gi");

    // Only rewrite text nodes; leave HTML tags untouched.
    return content
      .split(/(<[^>]+>)/g)
      .map((part) => {
        if (!part || part.startsWith("<")) {
          return part;
        }
        return part.replace(
          regex,
          '<mark class="keyword-highlight">$1</mark>',
        );
      })
      .join("");
  }

  private buildHighlightTerms(keyword: string): string[] {
    const full = keyword.trim();
    const tokens = full
      .split(/[\s,，、]+/)
      .map((t) => t.trim())
      .filter((t) => t.length >= 2);

    // Prefer longer matches first so "William Wong" wins over "William".
    const unique = Array.from(new Set([full, ...tokens]));
    return unique.sort((a, b) => b.length - a.length);
  }

  private escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
}
